import {Emitter} from '@wonderlandengine/api';

export class NotifyPropertyChanged {
    propertyChanged: Emitter<[string]> = new Emitter();

    notifyPropertyChanged(propertyName: string) {
        this.propertyChanged.notify(propertyName);
    }
}
